import React, { useState, useEffect } from "react"
import { AnimatePresence, motion } from "framer-motion"
import { graphql, Link, useStaticQuery } from "gatsby"

function Search({ visible, closeSearchBar }) {
  const [searchText, setSearchText] = useState("")
  const [blogs, setBlogs] = useState([])
  const [displaySearchResults, setDisplaySearchResults] = useState([])
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(filter: { frontmatter: { type: { eq: "blog" } } }) {
        edges {
          node {
            id
            frontmatter {
              title
              blog
              date
              category
              thumbnail
            }
          }
        }
      }
    }
  `)

  useEffect(() => {
    // console.log(data)
    if (data?.allMarkdownRemark.edges.length) {
      let _blogs = data.allMarkdownRemark.edges
      _blogs = _blogs.map(blog => ({
        id: blog.node.id,
        ...blog.node.frontmatter,
      }))
      setBlogs(_blogs)
      //   console.log(_blogs)
    }
  }, [data])

  useEffect(() => {
    if (searchText && blogs.length) {
      setDisplaySearchResults(
        blogs.filter(
          blog =>
            blog.title.toLowerCase().includes(searchText.toLowerCase()) ||
            blog.category
              .replace("-", "")
              .toLowerCase()
              .includes(searchText.toLowerCase())
        )
      )
    }
  }, [searchText, blogs])

  const handleCloseSearchBar = () => {
    closeSearchBar()
    setSearchText("")
  }

  return (
    <AnimatePresence exitBeforeEnter>
      {visible && (
        <div style={searchBoxStyle} className="container-fluid">
          <motion.div
            variants={searchVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="col-12 col-md-6 mx-2 mx-md-auto rounded p-2 bg-light text-dark d-block overflow-auto"
            style={{
              maxHeight: "75vh",
            }}
          >
            <div className="mb-2 d-flex align-items-center justify-content-between">
              <h5>Search Blogs</h5>
              <button
                className="btn btn-sm btn-secondary"
                onClick={handleCloseSearchBar}
              >
                Close
              </button>
            </div>
            <input
              type="text"
              className="my-2 form-control"
              placeholder="Type to search NStF Blogs"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
            />
            {searchText && (
              <div className="my-2">
                {displaySearchResults.length ? (
                  <div className="list-group list-group-flush px-1 py-2">
                    {displaySearchResults.map(item => (
                      <Link
                        key={item.id}
                        className="list-group-item text-decoration-none"
                        to={`/blogs/${item.blog}`}
                        onClick={handleCloseSearchBar}
                      >
                        <div className="d-flex align-items-start">
                          <div>
                            <img
                              src={require(`../images/thumbnails/${item.thumbnail}.png`)}
                              alt={item.thumbnail}
                              className="img-thumbnail"
                              style={{
                                maxWidth: 150,
                              }}
                            />
                          </div>
                          <div className="ml-2">
                            <h6>{item.title}</h6>
                            <p className="text-dark mb-0">
                              <small>
                                <i className="fas fa-clock mr-1"></i>
                                {item.date}
                              </small>
                            </p>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted text-center">No blogs found...</p>
                )}
              </div>
            )}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}

export default Search

const searchVariants = {
  hidden: {
    y: "-100vh",
  },
  visible: {
    y: "15vh",
    transition: { delay: 0.2, duration: 0.5, type: "spring", stiffness: 100 },
  },
  exit: {
    opacity: 0,
    transition: { ease: "easeInOut", duration: 0.3 },
  },
}

const searchBoxStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.5)",
  zIndex: 10,
  justifyContent: "center",
  // display: "flex",
  // alignItems: "center",
}
